import { EN_TO_DA, DA_TO_EN } from '@/components/en/EnLangSwitch';
const ORIGIN = 'https://enkelenergi.dk';
const DEFAULT_IMAGE = 'https://base44.app/api/apps/691da83d30e4689f56b0df07/files/mp/public/691da83d30e4689f56b0df07/77ba4fb0d_d9c1ec595_Enkel_LOGO-281.png';
export function canonicalPath(path) {
  const clean = String(path || '/').split(/[?#]/)[0].replace(/\/+$/, '') || '/';
  if (/^\/(home|forside)$/i.test(clean)) return '/';
  return clean.replace(/^\/SammenlignPage\//i, '/sammenlign/').toLowerCase();
}
export function setMeta(attribute, name, content) {
  const [existing, ...duplicates] = document.head.querySelectorAll(`meta[${attribute}="${name}"]`);
  duplicates.forEach(tag => tag.remove());
  let tag = existing;
  if (!tag) { tag = document.createElement('meta'); tag.setAttribute(attribute, name); document.head.appendChild(tag); }
  tag.content = content;
}
export function applyLanguageAlternates(path) {
  const current = canonicalPath(path);
  const en = EN_TO_DA[current] ? current : DA_TO_EN[current];
  const da = EN_TO_DA[current] || (en ? current : null);
  document.head.querySelectorAll('link[rel="alternate"][hreflang]').forEach(tag => tag.remove());
  // Navigation fallbacks are not translations: require a reciprocal page pair.
  if (!en || !da || EN_TO_DA[en] !== da || DA_TO_EN[da] !== en) return;
  for (const [language, target] of [['da', da], ['en', en], ['x-default', da]]) {
    const tag = document.createElement('link'); tag.rel = 'alternate'; tag.hreflang = language; tag.href = ORIGIN + target; document.head.appendChild(tag);
  }
}
export default function applyPageMetadata({ title, description, path, image, type }) {
  document.title = title;
  const article = /^\/(?:blogartikel|blogbestitest|elbilejeres-guldaeg|en\/blog\/)/i.test(path);
  setMeta('property', 'og:type', type || (article ? 'article' : 'website'));
  document.head.querySelectorAll('meta[property^="product:"]').forEach(tag => tag.remove());
  setMeta('name', 'description', description);
  setMeta('property', 'og:title', title);
  setMeta('property', 'og:description', description);
  setMeta('property', 'og:url', ORIGIN + canonicalPath(path));
  setMeta('name', 'twitter:title', title);
  setMeta('name', 'twitter:description', description);
  const pageImage = image || document.querySelector('#site-main [data-page-image]')?.getAttribute('data-page-image') || DEFAULT_IMAGE;
  setMeta('property', 'og:image', pageImage);
  setMeta('property', 'og:image:alt', pageImage === DEFAULT_IMAGE ? 'enkel energi logo' : title);
  setMeta('name', 'twitter:image', pageImage);
  setMeta('name', 'twitter:image:alt', pageImage === DEFAULT_IMAGE ? 'enkel energi logo' : title);
  // Do not declare guessed dimensions for route-specific photographs.
  document.head.querySelectorAll('meta[property="og:image:width"], meta[property="og:image:height"]').forEach(tag => tag.remove());
  const [existingCanonical, ...duplicates] = document.head.querySelectorAll('link[rel="canonical"]');
  duplicates.forEach(tag => tag.remove());
  const canonical = existingCanonical || document.createElement('link');
  canonical.rel = 'canonical';
  canonical.href = ORIGIN + canonicalPath(path);
  if (!existingCanonical) document.head.appendChild(canonical);
  const english = canonicalPath(path).startsWith('/en/') || canonicalPath(path) === '/en' || canonicalPath(path) === '/about-en';
  document.documentElement.lang = english ? 'en' : 'da';
  setMeta('name', 'language', english ? 'en' : 'da');
  setMeta('name', 'content-language', english ? 'en' : 'da');
  setMeta('property', 'og:locale', english ? 'en_GB' : 'da_DK');
  setMeta('property', 'og:locale:alternate', english ? 'da_DK' : 'en_GB');
  applyLanguageAlternates(path);
}